export const initialStatePageKey = 'crehanaLive';
export const CREHANA_LIVE_AMPLITUDE_PAGE_NAME = 'Crehana Live';
export const CREHANA_LIVE_PAGE_KEY = 'crehana-live';
export const KIDS_SLUG = 'ninos';
export const TABS_WIDTH_MD = '320px';
export const TABS_WIDTH_LG = '420px';
